
import { Box, Grid } from '@mui/material';
import InputForm from "../../../InputT";
import ParamsPicklist from "../../../../Types/ParamsPicklist";
import SearInputG from "../../../SearchInput"
import SelectMultipleOptionBasket from "../../../SelectMultipleOptionPanier";
import CheckBox from '../../../CheckBox';
import CheckboxF from '../../../ChexBox';
import { useState } from 'react';
import SelectOption from '../../../SelectOption';
import InputTauxDouble from '../../../InputTauxDouble';

//pour le compte de groupe
let searchParamsQard: ParamsPicklist = { CodeAgence: '', Table: "ParamsQard", Colonne1: "CodeQard", Colonne2: "LibelleQard", Colagence: '101', Choix: 22 }
let searchOperat  : ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchWorkflow  : ParamsPicklist = { CodeAgence: 'QARD', Table: "WorkflowEtape", Colonne1: "EtapeID", Colonne2: "LibelleEtape", Colagence: 'CodeFinancement', Choix: 22 }


const Tab1 = (props: { etatG?: boolean, form?: any, Function?: Function }) => {

const  [taxable,setTaxable]=useState(true);

 const handlerchangeIsttax=()=>{
    const Istaxable=props.form.getFieldValue("Istaxable");
    if(Istaxable){
        setTaxable(false);
        props.form.setFieldValue('MontantMintax',0)
    } else {
        setTaxable(true);
       props.form.setFieldValue('MontantMintax',0)
    }

   }



    return (
        <div className="tabItem">
            <Box  fontStyle="inherit"  className="border"  width={"85%"}   position={"absolute"}>
                <Box fontStyle="inherit" className="border-left">
                    <Grid container spacing={0}>
                        <Grid item xs={12} md={6}>
                            <SearInputG notRequired  dissabledCode={props.etatG} width={7} Titre="Recherche" label="Type de Qard"    name="CodeQard" Parametre={searchParamsQard} form={props.form}    />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <InputForm    width={3} label="Libellé"  type="text"   name="LibelleQard"  />
                        </Grid>

                        {/* Ligne 2 */}
                        <Grid item xs={12} md={4}>
                          <InputTauxDouble   width={12} label="Promesse de bonne foi (Taux min/ Montant min)"  name={['TauxMinPromesse', 'MontantMinPromesse']}   mode="exclusif"  />
                            {/* <InputForm  money width={12}  label="Fonds garanties"  type="number" name="FONDGARANTIE" /> */}
                        </Grid>
 
                        {/* <Grid item xs={12} md={4}>
                            <InputForm  money width={12}  label="Montant épargne requis"  type="number" name="MONTEPARG"
                            />
                        </Grid> */}

                        <Grid item xs={12} md={4}>
                            <InputForm money width={12}  label="Montant maximum autorisé"  type="number"  name="MontantMaxAuto"/>
                        </Grid>

                        {/* Ligne 3 */}
                        <Grid item xs={12} md={4}>
                            <InputForm  money   width={12} label="Nombre échéances maximum" type="number" name="NbrEchMax"/>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <InputForm money width={12} label="Jours constat créance impayée"   type="number" name="JrConstatImp" />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <InputForm  money  width={12} label="Jours constat créance douteuse" type="number" name="JrConstatDouteux" />
                        </Grid>

                        <Grid item xs={12} md={4} display={"flex"}  alignItems={"center"}>
                              <CheckboxF required onChange={(e:any)=>{handlerchangeIsttax()}}    width={16} label="Taxable ?" name="Istaxable" />
                              <InputForm disabled={taxable} notRequired money  width={8} label="Minimum Taxable" type="number" name="MontantMintax" />
                        </Grid>

                         <Grid item xs={12} md={4}>
                            <InputForm  money  width={12} label="Nombre Maximun de Qard Autorisé" type="number" name="NbrMaxAuto" />
                        </Grid>

                        <Grid item xs={12} md={4} display={"flex"}  >
                              {/* <CheckboxF  onChange={(e:any)=>{handlerchangeIsttax()}}    width={16} label="Taxable" name="Istaxable" /> */}
                              <InputForm  pourcent notRequired money  width={8} label="Taux Pénalité" type="number" name="TauxP" />
                        </Grid>

                        <Grid item xs={12} md={4}  >
                              {/* <CheckboxF  onChange={(e:any)=>{handlerchangeIsttax()}}    width={16} label="Taxable" name="Istaxable" /> */}
                              <SelectOption    Size={'middle'}   label="Workflow Frais"   name="WorkflowFrais" Parametre={searchWorkflow}  />
                        </Grid>
                        
                        <Grid item xs={12} md={4}>
                            <CheckboxF  CheCkDefauld  required   width={16} label="Garantie obligatoire ?" name="IsGarantieObligatoir" />
                        </Grid>

                        {/* Ligne 4 */}
                        <Grid item xs={12} style={{ marginTop: '20px', marginBottom: '20px' }}>
                            <SelectMultipleOptionBasket notRequired form={props.form}  Size="large"  width={4}  label="Frais de service"  name="Frais" Parametre={searchOperat}  />
                        </Grid>

                    </Grid>
                </Box>
            </Box>
        </div>
    );
};
     


export default Tab1;